import React from 'react';
import { useSelector } from 'react-redux';

const PaymentSummary = () => {
  // ✅ Removed unused 'selectedMeal' from destructuring
  const { selectedDate, selectedTime, totalPrice, orderItems } = 
    useSelector((state) => state.tiffin);

  if (orderItems.length === 0) {
    return null;
  }

  const gst = totalPrice * 0.18;
  const grandTotal = totalPrice + gst;

  return (
    <div className="card">
      <h2 className="section-title">💳 Payment Summary</h2>
      <div className="space-y-2">
        <div className="summary-row">
          <span>Subtotal</span>
          <span>₹{totalPrice}</span>
        </div>
        <div className="summary-row">
          <span>GST (18%)</span>
          <span>₹{gst.toFixed(2)}</span>
        </div>
        <div className="summary-row">
          <span>Delivery</span>
          <span>₹0.00</span>
        </div>
        <div className="summary-row total">
          <span>Grand Total</span>
          <span>₹{grandTotal.toFixed(2)}</span>
        </div>
        {selectedDate && (
          <div className="text-xs text-[var(--text-secondary)] mt-2">
            📅 {selectedDate} • 🕐 {selectedTime || 'Time not selected'}
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentSummary;